import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
 

@Injectable({
  providedIn: 'root'
})
export class PdfDownloadService {

  constructor() { }

  
  getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // required for CORS-safe conversion
      img.src = url;
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
  
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Canvas context is null');
  
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
  
      img.onerror = error => {
        reject(error);
      };
    });
  }
    
  downloadForExpensePDF(
    chartId: string,
    title: string,
    year: string,
    fromDate: string,
    toDate: string,
    selectedLabel: any,
    phiEdgeLogoDataUrl: string,   // base64 or image URL
    clientLogoDataUrl: string     // base64 or image URL
  ): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;
  
    const scaleFactor = 3;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      try {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
  
        const currentDate = new Date();
        const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  
        const pageWidth = pdf.internal.pageSize.getWidth();
        const marginX = 10;
  
        // Logos
        const logoHeight = 15;
        const phiEdgeLogoWidth = 40;
        const clientLogoWidth = 40;
  
        // Left logo
        // if (phiEdgeLogoDataUrl) {
        //   pdf.addImage(phiEdgeLogoDataUrl, 'PNG', marginX, 10, phiEdgeLogoWidth, logoHeight);
        // }
  
        // Right logo
        // if (clientLogoDataUrl) {
        //   pdf.addImage(clientLogoDataUrl, 'PNG', pageWidth - marginX - clientLogoWidth, 10, clientLogoWidth, logoHeight);
        // }
  
        // Title
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text(title, pageWidth / 2, 35, { align: 'center' });
  
        // Meta info
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
  
        let currentY = 45;
        if (year && chartElement.id !== 'bar-line-chart-nine-box' && chartElement.id !== 'table-employee-wise-trends-data') {
          pdf.text(`Year: ${year}`, 20, currentY);
          currentY += 7;
        } else if (year) {
          pdf.text(`Employee: ${year}`, 20, currentY);
          currentY += 7;
        }
  
        if (fromDate || toDate) {
          let dateRange = '';
          if (fromDate) dateRange += `From ${fromDate}`;
          if (toDate) dateRange += `  |  To ${toDate}`;
          pdf.text(`Date Range: ${dateRange}`, 20, currentY);
          currentY += 7;
        }
  
        if (selectedLabel) {
          pdf.text(`Selected Range: ${selectedLabel}`, 20, currentY);
          currentY += 10;
        }
  
        // Separator line
        pdf.setDrawColor(200);
        pdf.line(20, currentY, pageWidth - 20, currentY);
        currentY += 5;
  
        // Chart image
        const imgWidth = pageWidth - 20;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 10, currentY, imgWidth, imgHeight);
        currentY += imgHeight + 10;
  
        // Footer
        const footerY = 285;
        pdf.setFontSize(10);
        pdf.setTextColor(120);
        pdf.text(`Generated on: ${todayDate}`, 20, footerY);
  
        const logoWidth = 20;
        const logoHeight1 = 10;
        const marginRight = 10;
        const gapBetweenTextAndLogo = 5;
        const logoX = pageWidth - marginRight - logoWidth;
        const poweredByTextWidth = pdf.getTextWidth('Powered by ');
        const poweredByX = logoX - gapBetweenTextAndLogo - poweredByTextWidth;
  
        pdf.text('Powered by ', poweredByX, footerY);
        if (phiEdgeLogoDataUrl) {
          pdf.addImage(phiEdgeLogoDataUrl, 'PNG', logoX, footerY - logoHeight1 + 3, logoWidth, logoHeight1);
        }
  
        pdf.save(`${title}-${todayDate}.pdf`);
      } catch (error) {
        console.error('Error generating PDF:', error);
        alert('There was an error generating the PDF. Please check the chart or logo image.');
      }
    }).catch(err => {
      console.error('html2canvas failed:', err);
      alert('Failed to render chart. Make sure the chart is visible on screen.');
    });
  }
  


  downloadForExpensePDF36(
    chartId: string,
    title: string,
    year: string,
    fromDate: string,
    toDate: string,
    selectedLabel: any,
    phiEdgeLogoDataUrl: string,   // base64 or image URL for PhiEdge logo
    clientLogoDataUrl: string     // base64 or image URL for Client logo
  ): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;
  
    const scaleFactor = 3;
  
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
  
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  
      const pageWidth = pdf.internal.pageSize.getWidth();
  
      // 1. Add Logos at top left and top right
      const logoHeight = 15; // mm
      const phiEdgeLogoWidth = 40;
      const clientLogoWidth = 40;
  
      if (phiEdgeLogoDataUrl) {
        pdf.addImage(phiEdgeLogoDataUrl, 'PNG', 10, 10, phiEdgeLogoWidth, logoHeight);
      }
  
      // if (clientLogoDataUrl) {
      //   pdf.addImage(clientLogoDataUrl, 'PNG', pageWidth - 10 - clientLogoWidth, 10, clientLogoWidth, logoHeight);
      // }
  
      // 2. Title centered below logos (vertical position ~35)
      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
      pdf.text(title, pageWidth / 2, 35, { align: 'center' });
  
      // 3. Meta info below title
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'normal');
  
      let currentY = 45;
      if (year && chartElement.id !== 'bar-line-chart-nine-box' && chartElement.id !== 'table-employee-wise-trends-data') {
        pdf.text(`Year: ${year}`, 20, currentY);
        currentY += 7;
      } else if (year) {
        pdf.text(`Employee: ${year}`, 20, currentY);
        currentY += 7;
      }
  
      if (fromDate || toDate) {
        let dateRange = '';
        if (fromDate) dateRange += `From ${fromDate}`;
        if (toDate) dateRange += `  |  To ${toDate}`;
        pdf.text(`Date Range: ${dateRange}`, 20, currentY);
        currentY += 7;
      }
  
      if (selectedLabel) {
        pdf.text(`Selected Range: ${selectedLabel}`, 20, currentY);
        currentY += 10;
      }
  
      // Optional separator line
      pdf.setDrawColor(200);
      pdf.line(20, currentY, pageWidth - 20, currentY);
      currentY += 5;
  
      // 4. Chart image below meta info
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, currentY, imgWidth, imgHeight); // here error
      currentY += imgHeight + 10;
  
      // 5. Footer (optional)
      const footerY = 285;
      pdf.setFontSize(10);
      pdf.setTextColor(120);
      
      const pageWidth1 = pdf.internal.pageSize.getWidth();
      const logoWidth = 20;
      const logoHeight1 = 10;
      const marginRight = 10;
      const gapBetweenTextAndLogo = 5;
      
      // Left side - Generated on date
      pdf.text(`Generated on: ${todayDate}`, 20, footerY);
      
      // Right side - Powered by text and logo
      const logoX = pageWidth1 - marginRight - logoWidth;
      const poweredByTextWidth = pdf.getTextWidth('Powered by ');
      
      // Position the "Powered by " text so it's just to the left of the logo with some gap
      const poweredByX = logoX - gapBetweenTextAndLogo - poweredByTextWidth;
      
      pdf.text('Powered by ', poweredByX, footerY);
      
      if (phiEdgeLogoDataUrl) {
        pdf.addImage(phiEdgeLogoDataUrl, 'PNG', logoX, footerY - logoHeight1 + 3, logoWidth, logoHeight1);
      }
      

      
      // pdf.text('Powered by PhiEdge HRMS', pageWidth - 80, 285);
  
      // Save PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
  
  downloadForExpensePDF66(
    chartId: string,
    title: string,
    year: string,
    fromDate: string,
    toDate: string,
    selectedLabel: any,
    phiEdgeLogoDataUrl: string,   // base64 or image URL for PhiEdge logo
    clientLogoDataUrl: string     // base64 or image URL for Client logo
  ): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;
  
    const scaleFactor = 3;
  
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
  
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  
      // 1. Add Logos
      const logoHeight = 15; // height in mm
      const phiEdgeLogoWidth = 40;
      const clientLogoWidth = 40;
  
      // Add PhiEdge logo at top-left (x=10, y=10)
      if (phiEdgeLogoDataUrl) {
        pdf.addImage(phiEdgeLogoDataUrl, 'PNG', 10, 10, phiEdgeLogoWidth, logoHeight);
      }
  
      // Add Client logo at top-right (x = pageWidth - margin - logoWidth)
      const pageWidth = pdf.internal.pageSize.getWidth();
      if (clientLogoDataUrl) {
        pdf.addImage(clientLogoDataUrl, 'PNG', pageWidth - 10 - clientLogoWidth, 10, clientLogoWidth, logoHeight);
      }
  
      // 2. Title centered between logos vertically aligned with logos
      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
  
      // Center horizontally (pageWidth/2) and vertically roughly aligned with logos (y=17)
      pdf.text(title, pageWidth / 2, 17, { align: 'center' });
  
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'normal');
  
      // 3. Meta info below logos and title
      let currentY = 30;
      if (year && chartElement.id !== 'bar-line-chart-nine-box' && chartElement.id !== 'table-employee-wise-trends-data') {
        pdf.text(`Year: ${year}`, 20, currentY);
        currentY += 7;
      } else if (year) {
        pdf.text(`Employee: ${year}`, 20, currentY);
        currentY += 7;
      }
  
      if (fromDate || toDate) {
        let dateRange = '';
        if (fromDate) dateRange += `From ${fromDate}`;
        if (toDate) dateRange += `  |  To ${toDate}`;
        pdf.text(`Date Range: ${dateRange}`, 20, currentY);
        currentY += 7;
      }
  
      if (selectedLabel) {
        pdf.text(`Selected Range: ${selectedLabel}`, 20, currentY);
        currentY += 10;
      }
  
      // Optional separator line
      pdf.setDrawColor(200);
      pdf.line(20, currentY, pageWidth - 20, currentY);
      currentY += 5;
  
      // 4. Add Chart Image
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 10;
  
      // 5. Footer (optional)
      pdf.setFontSize(10);
      pdf.setTextColor(120);
      pdf.text(`Generated on: ${todayDate}`, 20, 285);
      pdf.text('Powered by PhiEdge HRMS', pageWidth - 80, 285);
  
      // Save PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  

  downloadForExpensePDF1(
    chartId: string,
    title: string,
    year: string,
    fromDate: string,
    toDate: string,
    selectedLabel: any
  ): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;
  
    const scaleFactor = 3;
  
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
  
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  
      // 1. Title Centered
      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
      pdf.text(title, 105, 15, { align: 'center' });
  
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'normal');
  
      // 2. Meta Data (Year, Range, Label)
      let currentY = 25;
      if (year && chartElement.id !== 'bar-line-chart-nine-box' && chartElement.id !== 'table-employee-wise-trends-data') {
        pdf.text(`Year: ${year}`, 20, currentY);
        currentY += 7;
      } else if (year) {
        pdf.text(`Employee: ${year}`, 20, currentY);
        currentY += 7;
      }
  
      if (fromDate || toDate) {
        let dateRange = '';
        if (fromDate) dateRange += `From ${fromDate}`;
        if (toDate) dateRange += `  |  To ${toDate}`;
        pdf.text(`Date Range: ${dateRange}`, 20, currentY);
        currentY += 7;
      }
  
      if (selectedLabel) {
        pdf.text(`Selected Range: ${selectedLabel}`, 20, currentY);
        currentY += 10;
      }
  
      // Optional Line Divider
      pdf.setDrawColor(200);
      pdf.line(20, currentY, 190, currentY);
      currentY += 5;
  
      // 3. Add Chart Image
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 10;
  
      // 4. Footer (optional)
      pdf.setFontSize(10);
      pdf.setTextColor(120);
      pdf.text(`Generated on: ${todayDate}`, 20, 285);
      pdf.text('Powered by PhiEdge HRMS', 150, 285);
  
      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  

  downloadForExpensePDFOld(
    chartId: string,
    title: string,
    year: string,
    fromDate: string,
    toDate: string,
    selectedLabel: any
  ): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;
  
    const scaleFactor = 3;
  
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
  
      // Get the current date
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  
      // Title centered at top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });
  
      // Vertical spacing and text layout
      let currentY = 20; // Y position after title
      pdf.setFontSize(12);
  
      // Print Year or Employee
      if (year && chartElement.id !== 'bar-line-chart-nine-box' && chartElement.id !== 'table-employee-wise-trends-data') {
        pdf.text(`Year: ${year}`, 20, currentY);
      } else if (year) {
        pdf.text(`Employee: ${year}`, 20, currentY);
      }
  
      currentY += 7;
  
      // From - To Date
      let dateText = '';
      if (fromDate) dateText += `From: ${fromDate}`;
      if (toDate) dateText += `${fromDate ? '  |  ' : ''}To: ${toDate}`;
      pdf.text(dateText, 20, currentY);
  
      currentY += 7;
  
      // Option Type (selected label)
      if (selectedLabel) {
        pdf.text(`Filter Used: ${selectedLabel}`, 20, currentY);
      }
  
      currentY += 10; // Add some space before chart image
  
      // Chart image
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, currentY, imgWidth, imgHeight);
  
      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }




  downloadPDF(chartId: string, title: string, year: string, fromDate: string, toDate: string): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    // Increase the scale factor for better quality (e.g., 2 for HD)
    const scaleFactor = 3;

    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);
      if(year && chartElement.id != 'bar-line-chart-nine-box' && chartElement.id != 'table-employee-wise-trends-data'){
        pdf.text(`Year: ${year}`, 10, 17); // Year on the left
      }else{
        if(year){
          pdf.text(`Employee: ${year}`, 10, 17); // Year on the left
        }
        
      }
      if (fromDate || toDate) {
        let dateText = '';
        if (fromDate) dateText += `From: ${fromDate}`;
        if (toDate) dateText += `${fromDate ? ' | ' : ''}To: ${toDate}`;
        pdf.text(dateText, 120, 17); // Display date range on the right
      }

 

      // Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
 
   
  downloadPDFMonthwise(chartId: string, title: string, year: string, month: string, frequency?: string): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    // Increase the scale factor for better quality (e.g., 2 for HD)
    const scaleFactor = 3;

    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);
      pdf.text(`Year: ${year}`, 10, 17); // Year on the left

      if (month ) {
        let dateText = '';
        if (month) dateText += `Month: ${month}`;
        // if (toDate) dateText += `${fromDate ? ' | ' : ''}To: ${toDate}`;
        pdf.text(dateText, 150, 17); // Display date range on the right
      }
      if (frequency) {
        pdf.text(`Frequency: ${frequency}`, 150, 17); // Add frequency if available
      }
 

      // Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
   



  downloadPDFMonthwiseAndDepart(chartId: string, title: string, year: any, month: string,department:any): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    // Increase the scale factor for better quality (e.g., 2 for HD)
    const scaleFactor = 3;

    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);


      // Left side: Year and Month together
      let yearText = year ? `Year: ${year}` : '';
      let monthText = month ? `Month: ${month}` : '';
      let combinedText = `${yearText}${monthText ? ' | ' + monthText : ''}`;
      pdf.text(combinedText, 10, 17);
      
      // Right side: Department (properly labeled)

 if(title=='Total Exited Vs Resigned Vs Terminated'){


      if (department.length>0) {
        console.log(department)
        let filterdata=department.map((elm:any)=>elm.name);
        console.log(filterdata)
        let deptText = department.length>0? `Department: ${filterdata}`:'';
        pdf.text(deptText, 150, 17); // adjust X if needed for better alignment
      }
      
 }else if(title !=='Total Exited Vs Resigned Vs Terminated'){

  if (department) {
     let deptText = department? `Department: ${department}`:'';
     pdf.text(deptText, 150, 17); // adjust X if needed for better alignment
   }
 }
      
// Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

}
